<template>
  <a-modal :width="width" :footer="null" :wrapClassName="isFullScreen?'full-modal':'no-full-modal'" v-model="visible" @ok="handleOk">
    <template slot="title">
      <div class="flex jus-con-bet title-box">
        <div>查看</div>
        <div>
          <a-icon v-if="!isFullScreen" @click="openScreen" type="fullscreen" />
          <a-icon v-else @click="openScreen" type="fullscreen-exit" />
        </div>
      </div>
    </template>
    <div class="">
        <!-- <div v-if=" ['.pdf'].includes(file.fileSuffix) ">
            <iframe :src="file.url" class="iframe" frameborder="0"></iframe>
        </div> -->
        <img  class="img" :src="file.url" alt="">
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    // 文件
    file: {
      type: Object,
      default: () => ({}),
    },
    // 默认弹窗宽度
    defautlWidth:{
        type:[Number,String],
        default:800
    }
  },
  watch:{
    defautlWidth:{
        handler(){
            this.width = this.defautlWidth
        },
        immediate:true
    }
  },
  data() {
    return {
    
      visible: false,
      isFullScreen: false, //是否放大
      width:800,
    }
  },
  methods: {
    handleOk() {
      this.visible = false
    },
    open() {
      this.visible = true
    },
    openScreen(){
        if(!this.isFullScreen){
            this.width = '100vw'

        }else{
            this.width = 800
        }
        this.isFullScreen = !this.isFullScreen
        
    }
  },
}
</script>

<style lang="less" scoped>
.flex {
  display: flex;
//   width: 90%;
}
.jus-con-bet{
    justify-content: space-between;
}
.img,.iframe{
    width: 100%;
}
 /deep/ .no-full-modal{
   /deep/ .ant-modal{
        height: 500px!important;
    }
}
 /deep/ .full-modal{
    /deep/ .ant-modal{
        height: 100vh!important;
    }
}
/deep/ .ant-modal-header{
    padding-top: 6px!important;
}
</style>
